import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-2" }, "Plan", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-2" }, "Policy", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Procedure", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Submission Count", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "Acceptance %", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "Status", -1)
const _hoisted_7 = { class: "plan-name col-span-2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "font-bold text-gray-300"
}
const _hoisted_10 = { class: "policy-name col-span-2" }
const _hoisted_11 = {
  key: 0,
  class: "tooltip-container relative cursor-help"
}
const _hoisted_12 = {
  key: 1,
  class: "font-bold text-gray-300"
}
const _hoisted_13 = { class: "procedure-code" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "font-bold text-gray-300"
}
const _hoisted_16 = { class: "submission-count" }
const _hoisted_17 = { class: "acceptance-rate" }
const _hoisted_18 = { class: "protocol-status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableHeader = _resolveComponent("TableHeader")!
  const _component_TableFetchState = _resolveComponent("TableFetchState")!
  const _component_TableErrorState = _resolveComponent("TableErrorState")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Selection = _resolveComponent("Selection")!
  const _component_TableRow = _resolveComponent("TableRow")!
  const _component_TableList = _resolveComponent("TableList")!

  return (_openBlock(), _createBlock(_component_TableList, { class: "grid-cols-8" }, {
    default: _withCtx(() => [
      _createVNode(_component_TableHeader, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1
      }),
      (_ctx.fetchStatus === _ctx.FetchStatus.FETCHING)
        ? (_openBlock(), _createBlock(_component_TableFetchState, {
            key: 0,
            class: "col-span-6"
          }))
        : (_ctx.fetchStatus === _ctx.FetchStatus.FAILURE)
          ? (_openBlock(), _createBlock(_component_TableErrorState, {
              key: 1,
              class: "col-span-6",
              onRetry: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry'))),
              "allow-retry": ""
            }))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.sortedByCount.slice(0, 100), (protocol, i) => {
              return (_openBlock(), _createBlock(_component_TableRow, {
                class: "protocol",
                key: i
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    (protocol.planId)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(protocol.planName), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, "None"))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (protocol.policyId)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                          _createTextVNode(_toDisplayString(protocol.policyId) + " ", 1),
                          _createVNode(_component_Tooltip, {
                            text: protocol.policyName
                          }, null, 8, ["text"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, "None"))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (protocol.procedureCode)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(protocol.procedureCode), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15, "None"))
                  ]),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(protocol.submissionCount), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(protocol.acceptanceRate.toFixed(1)) + "%", 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_Selection, {
                      "onUpdate:value": ($event: any) => (_ctx.updateProtocol(protocol, $event)),
                      value: _ctx.getSelectedValue(protocol),
                      options: _ctx.autoAdjudicationsOptions
                    }, null, 8, ["onUpdate:value", "value", "options"])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
    ]),
    _: 1
  }))
}